"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSupplyAdd = void 0;
const Base_1 = require("./Base");
exports.PostSupplyAdd = {
    url: Base_1.URL_BASE + "/SupplyAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSupplyAdd.js.map